import React, { useContext, useMemo } from "react";
import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import _ from "lodash";
import { EntityProfileContext } from ".";
import ProfileAvatar from "./ProfileAvatar";

function ProfileDetailsHeader() {
    const { entity, fields } = useContext(EntityProfileContext);

    const titleField = useMemo(() => fields.find((field) => field.id === "title"), [fields]);
    const subTitleField = useMemo(() => fields.find((field) => field.id === "subtitle"), [fields]);
    const imageField = useMemo(() => fields.find((field) => field.id === "image"), [fields]);

    const subTitle = useMemo(() => entity[subTitleField?.name], [entity, subTitleField]);
    const imageUrl = useMemo(
        () =>
            typeof entity[imageField?.name] === "string"
                ? entity[imageField?.name]
                : entity[imageField?.name]?.url,
        [entity, imageField]
    );

    return (
        <EuiFlexGroup
            justifyContent="spaceBetween"
            alignItems="center"
            className="profile-details__section-wrapper"
        >
            <EuiFlexItem grow={false}>
                <ProfileAvatar
                    id={entity.id}
                    title={entity[titleField?.name]}
                    subtitle={subTitleField?.format ? _.startCase(subTitle) : subTitle}
                    imageUrl={imageUrl}
                />
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}

export default ProfileDetailsHeader;
